import { useRef } from "react";

import { useGameCanvasRefsAndMetrics } from "./boardHooks";
import { GameCanvasLayout } from "./boardLayout";
import { GameCanvasOverlayLayoutProvider } from "./overlayLayoutContext";
import type { GameCanvasProps } from "./types";

export function GameCanvas(props: GameCanvasProps) {
  const overlayRootRef = useRef<HTMLDivElement | null>(null);
  const { canvasRef, viewportRef, displayScale, cssWidth, cssHeight, stickInspectOnClick } =
    useGameCanvasRefsAndMetrics(props);
  const { state, cursorMode, onTileSelect, onTileHover, onCancelSelection, viewportOverlay } =
    props;
  return (
    <GameCanvasOverlayLayoutProvider
      value={{ overlayRootRef, canvasRef, viewportRef, displayScale }}
    >
      <GameCanvasLayout
        overlayRootRef={overlayRootRef}
        viewportRef={viewportRef}
        canvasRef={canvasRef}
        cursorMode={cursorMode}
        cssWidth={cssWidth}
        cssHeight={cssHeight}
        boardWidth={state.width}
        boardHeight={state.height}
        theme={state.theme}
        onTileSelect={onTileSelect}
        onTileHover={onTileHover}
        onCancelSelection={onCancelSelection}
        stickInspectOnClick={stickInspectOnClick}
        viewportOverlay={viewportOverlay}
      />
    </GameCanvasOverlayLayoutProvider>
  );
}
